import Picture from "../Picture/Picture.jsx";
import Breadcrumbs from "../Breadcrumbs/Breadcrumbs.jsx";
import styles from "./PageHero.module.css";

export default function PageHero({ eyebrow, title, lead, image, imageAlt, breadcrumbs, children }) {
  return (
    <section className={`section-dark ${styles.hero}`}>
      <div className={`container ${styles.inner} ${image ? styles.withImage : ""}`.trim()}>
        <div className={styles.text}>
          {breadcrumbs ? <Breadcrumbs items={breadcrumbs} /> : null}
          {eyebrow ? <p className="eyebrow">{eyebrow}</p> : null}
          <h1>{title}</h1>
          {lead ? <p className={styles.lead}>{lead}</p> : null}
          {children}
        </div>
        {image ? (
          <Picture
            src={image}
            alt={imageAlt}
            priority
            sizes="(min-width: 64rem) 45vw, 100vw"
            className={styles.image}
          />
        ) : null}
      </div>
    </section>
  );
}
